export default "__VITE_ASSET__BAUwGBJw__"